__turbopack_context__.v({
  "root": "PlasmicSliderThumb-module__2ungTa__root",
});
